var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1400px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("订单详情")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "demo-drawer__content",
            },
            [
              _vm.orderDatalist
                ? _c(
                    "div",
                    { staticClass: "description" },
                    [
                      parseFloat(_vm.orderDatalist.shippingType) === 3
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("核销信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "服务类型：" +
                                    _vm._s(
                                      _vm.orderDatalist.supplierResult
                                        ? _vm.orderDatalist.supplierResult
                                            .serviceName
                                        : "-"
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "核销码：" +
                                    _vm._s(
                                      _vm.orderDatalist.supplierResult
                                        ? _vm.orderDatalist.supplierResult
                                            .verifyCode
                                        : "-"
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "推送手机号码：" +
                                    _vm._s(
                                      _vm.orderDatalist.userRechargeInfo
                                        ? _vm.orderDatalist.userRechargeInfo
                                            .rechargeAccount
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "有效期：" +
                                    _vm._s(
                                      _vm.orderDatalist.supplierResult
                                        ? _vm.orderDatalist.supplierResult
                                            .endTime
                                        : "-"
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-divider"),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("核销门店信息"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "acea-row" }, [
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "门店名称：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo
                                        .storeName
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "联系电话：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo
                                        .storePhone
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "地址：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo
                                        .storeAddress
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "核销员：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo.name
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "核销员手机号：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo.phone
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "门店价格：￥" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo
                                        .originalPrice
                                    : "-"
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "核销时间：" +
                                _vm._s(
                                  _vm.orderDatalist.verificationInfo
                                    ? _vm.orderDatalist.verificationInfo
                                        .verificationTime
                                    : "-"
                                )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-divider"),
                      ],
                      _vm._v(" "),
                      _vm.channelVisBle
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("渠道订单信息"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.orderDatalist
                                      .supplierOrderDetailList,
                                    size: "mini",
                                    "highlight-current-row": true,
                                    "header-cell-style": { fontWeight: "bold" },
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c(
                                                "el-row",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "5px",
                                                  },
                                                  attrs: {
                                                    type: "flex",
                                                    align: "middle",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 7 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 渠道订单号： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(
                                                          row.supplierOrderNo
                                                        ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 供应商商户： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(row.channel) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    { attrs: { span: 4 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " 渠道订单状态： "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "supplierOrderLogisticsStatusFilterByOffset"
                                                            )(row.orderStatus)
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right",
                                                        "padding-right": "10px",
                                                      },
                                                      attrs: { span: 10 },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                            "font-weight":
                                                              "bold",
                                                          },
                                                        },
                                                        [_vm._v(" 下单时间：")]
                                                      ),
                                                      _vm._v(
                                                        _vm._s(row.createTime) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-table",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px",
                                                  },
                                                  attrs: {
                                                    data: row.supplierOrderDetailList,
                                                    border: "",
                                                    "show-header": true,
                                                  },
                                                },
                                                [
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品图",
                                                      "min-width": "80",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "demo-image__preview",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-image",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "36px",
                                                                          height:
                                                                            "36px",
                                                                        },
                                                                      attrs: {
                                                                        src: scope
                                                                          .row
                                                                          .image,
                                                                        "preview-src-list":
                                                                          [
                                                                            scope
                                                                              .row
                                                                              .image,
                                                                          ],
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品名称",
                                                      prop: "productName",
                                                      "min-width": "120",
                                                      align: "center",
                                                      "show-overflow-tooltip": true,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "SKU名称",
                                                      prop: "skuName",
                                                      "min-width": "120",
                                                      align: "center",
                                                      "show-overflow-tooltip": true,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商品售价",
                                                      prop: "price",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .price
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商户支付价",
                                                      prop: "payPrice",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .payPrice
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "商户成本价",
                                                      prop: "vipPrice",
                                                      "min-width": "100",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "￥" +
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .vipPrice
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      prop: "payNum",
                                                      label: "购买数量",
                                                      "min-width": "80",
                                                      align: "center",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "订单状态",
                                                      prop: "orderStatus",
                                                      "min-width": "80",
                                                      "show-overflow-tooltip": true,
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "  " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "supplierOrderStatusFilter"
                                                                      )(
                                                                        scope
                                                                          .row
                                                                          .orderStatus
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "物流状态",
                                                      prop: "orderStatus",
                                                      "min-width": "100",
                                                      "show-overflow-tooltip": true,
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "supplierOrderLogisticsStatusFilterByOffset"
                                                                      )(
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("el-table-column", {
                                                    attrs: {
                                                      label: "操作",
                                                      "min-width": "250",
                                                      fixed: "right",
                                                      align: "center",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (scope) {
                                                            return [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "2" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "5" ||
                                                                        scope
                                                                          .row
                                                                          .logisticsStatus ===
                                                                          "6",
                                                                      expression:
                                                                        "scope.row.logisticsStatus === '2' || scope.row.logisticsStatus === '5' || scope.row.logisticsStatus === '6'",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.confirmGoods(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("核销")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        !scope
                                                                          .row
                                                                          .disputeId &&
                                                                        !_vm
                                                                          .orderDatalist
                                                                          .isVirtual,
                                                                      expression:
                                                                        "!scope.row.disputeId && !orderDatalist.isVirtual",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRefund(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "申请退款"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  directives: [
                                                                    {
                                                                      name: "show",
                                                                      rawName:
                                                                        "v-show",
                                                                      value:
                                                                        scope
                                                                          .row
                                                                          .disputeId,
                                                                      expression:
                                                                        "scope.row.disputeId",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    type: "text",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleRefundDetail(
                                                                          scope.row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "退款详情"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2730643615
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("div", { staticClass: "title" }, [
                                _vm._v("商品信息"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "mini",
                                    data: _vm.orderDatalist.orderDetailList,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "商品图", width: "80" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "demo-image__preview",
                                                },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src: scope.row.image,
                                                      "preview-src-list": [
                                                        scope.row.image,
                                                      ],
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1825039654
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "商品名称",
                                      prop: "productName",
                                      "min-width": "200",
                                      "show-overflow-tooltip": true,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "price",
                                      label: "商品售价",
                                      "min-width": "90",
                                      align: "center",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "sku",
                                      label: "商品规格",
                                      "min-width": "90",
                                      align: "center",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "acea-row" }, [
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "\n            订单号：" +
                              _vm._s(_vm.orderDatalist.orderNo) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "description-term",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v("\n            订单状态：\n            "),
                            _vm.orderDatalist.refundStatus === 3
                              ? _c("span", [_vm._v("已退款")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("orderStatusFilterByOffset")(
                                        _vm.orderDatalist.status
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付状态：" +
                              _vm._s(
                                _vm.orderDatalist.paid ? "已支付" : "未支付"
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商品总数：" + _vm._s(_vm.orderDatalist.totalNum)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商品总价：" +
                              _vm._s(_vm.orderDatalist.proTotalPrice)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "实际支付：" + _vm._s(_vm.orderDatalist.vipPrice)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付方式：" +
                              _vm._s(
                                _vm._f("payTypeFilter")(
                                  _vm.orderDatalist.payType
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "\n            配送方式：到店核销\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "创建时间：" + _vm._s(_vm.orderDatalist.createTime)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付时间：" + _vm._s(_vm.orderDatalist.payTime)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "用户备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.userRemark
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商家备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.merchantRemark
                                )
                              )
                          ),
                        ]),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款",
            visible: _vm.dialogFormVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "退款类型", "label-width": "100px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择退款类型" },
                      model: {
                        value: _vm.form.bizClaimType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bizClaimType", $$v)
                        },
                        expression: "form.bizClaimType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "仅退款", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "货物状态", "label-width": "100px" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择货物状态" },
                      model: {
                        value: _vm.form.goodsStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "goodsStatus", $$v)
                        },
                        expression: "form.goodsStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未收到货", value: "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.maxRefundFee
                ? _c(
                    "el-form-item",
                    { attrs: { label: "退款金额", "label-width": "100px" } },
                    [_c("span", [_vm._v("￥" + _vm._s(_vm.form.maxRefundFee))])]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleOnsubmitRefund()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }